import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/images/logo_no_shadow.png'


const _hoisted_1 = { class: "destroy-con" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "logo"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "destroy-title" }, "账号注销风险", -1)
const _hoisted_4 = { class: "destroy-main" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h4", { class: "main-title" }, "无法登录", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "一旦注销，您将无法使用该账号登录「好未来图书」服务平台。", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h4", { class: "main-title" }, "信息抹除，无法恢复", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "注销后将同时永久抹除「好未来图书」服务平台的所有数据信息。包含但不限于以下： ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, "1、个人资料； ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, "2、账户资产，积分等失效且无法恢复；", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", null, "3、学习等级、学习时长、学习记录、学习排名，错题本数据等将被清空；", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "sp" }, "注意：同一手机号，再次注册，数据无法恢复", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _hoisted_6,
      _hoisted_7,
      _hoisted_8,
      _hoisted_9,
      _hoisted_10,
      _hoisted_11,
      _hoisted_12,
      _createElementVNode("span", {
        class: "destroy-btn",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.confirmDestroy()))
      }, "我已清楚风险，确认注销")
    ])
  ]))
}